import { getField, updateField } from 'vuex-map-fields'

import product from '../../../api/product/product'

// initial state
const state = {
  products: {
    AllIncludeOptions: [],
    OtherProducts: [],
    Products: []
  },
  productDetail: {
    BasePrice: 0,
    CategoryId: 0,
    CategoryName: '',
    ProductId: 0,
    ProductName: '',
    ProductsMainOptionId: 0,
    ProductsMainOptionName: '',
    ProductsOptions: [],
    quantity: 1,
    OptionsVariantIds: []
  }
}

// getters
const getters = {
  getField,
  finish: (state, getters) => {
    const selOptionIds = state.productDetail.OptionsVariantIds
    const needOptions = state.productDetail.ProductsOptions.filter(a => !a.AllowNo && a.DisplayNoOption)
    if (needOptions === null || needOptions === undefined || needOptions.length < 1) {
      return true
    }
    var selCount = 0
    for (var i = 0; i < needOptions.length; i++) {
      const vars = needOptions[i].Variants
      for (var j = 0; j < vars.length; j++) {
        if (selOptionIds.indexOf(vars[j].OptionsVariantId) > -1) {
          selCount++
          break
        }
      }
    }
    return selCount >= needOptions.length
  }
}

// actions
const actions = {
  getProductList ({ commit, rootGetters }, data) {
    if (data === null || data === undefined) {
      return new Promise.reject(new Error(''))
    }
    var catId = 0
    const categoryList = rootGetters['category/categoryList']
    if (categoryList === null || categoryList === undefined || categoryList.length < 1) {
      this.dispatch('category/getCategory')
        .then((catlist) => {
          const tmpCategory = catlist.filter(a => a.UrlAliase === data.path)
          if (tmpCategory !== null && tmpCategory.length > 0) {
            catId = tmpCategory[0].CategoryId
          }
          const catData = {
            CategoryId: parseInt(catId)
          }
          return new Promise((resolve, reject) => {
            product.getProduct(catData)
              .then(res => {
                commit('setProducts', res)
                resolve(res)
              })
              .catch((error) => {
                reject(error)
              })
          })
        })
    } else {
      const tmpCategory = categoryList.filter(a => a.UrlAliase === data.path)
      if (tmpCategory !== null && tmpCategory.length > 0) {
        catId = tmpCategory[0].CategoryId
      }
      const catData = {
        CategoryId: parseInt(catId)
      }
      return new Promise((resolve, reject) => {
        product.getProduct(catData)
          .then(res => {
            commit('setProducts', res)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  },
  getProductDetails ({ commit }, data) {
    return new Promise((resolve, reject) => {
      product.getProductDetail(data.productId, data.optionId)
        .then(res => {
          commit('setProductDetail', res)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  changeQuantity ({ state, commit }, qty) {
    commit('changeQuantity', qty)
  },
  selectOption ({ state, commit }, id) {
    commit('selectOption', id)
  },
  resetOption ({ state, commit }, option) {
    commit('resetOption', option)
  }
}

// mutations
const mutations = {
  updateField,
  setProducts (state, res) {
    const tmpProducts = res.Products.map(item => {
      item.quantity = 1
      return item
    })
    res.Products = tmpProducts
    state.products = res
  },
  setProductDetail (state, res) {
    res.quantity = 1
    var ids = []
    for (var i = 0; i < res.ProductsOptions.length; i++) {
      for (var j = 0; j < res.ProductsOptions[i].Variants.length; j++) {
        if (res.ProductsOptions[i].Variants[j].Standard) {
          ids.push(res.ProductsOptions[i].Variants[j].OptionsVariantId)
        }
      }
      if (res.ProductsOptions[i].AllowNo && res.ProductsOptions[i].DisplayNoOption) {
        res.ProductsOptions[i].Variants.push({
          OptionsVariantId: 0 - res.ProductsOptions[i].ProductsOptionId,
          OptionsVariantName: 'No ' + res.ProductsOptions[i].ProductsOptionName,
          OptionsVariantPrice: 0,
          PhotoKey: '',
          Standard: false
        })
      }
    }
    res.OptionsVariantIds = ids
    state.productDetail = res
  },
  changeQuantity (state, qty) {
    state.productDetail.quantity = qty
  },
  resetOption (state, option) {
    var ids = state.productDetail.OptionsVariantIds
    if (option.Variants.length < 1) {
      return
    }
    for (var i = 0; i < option.Variants.length; i++) {
      const index = ids.indexOf(option.Variants[i].OptionsVariantId)
      if (index >= 0) {
        ids.splice(index, 1)
      }
    }
    for (var j = 0; j < option.Variants.length; j++) {
      if (option.Variants[j].Standard === true) {
        ids.push(option.Variants[j].OptionsVariantId)
      }
    }
  },
  selectOption (state, id) {
    var ids = state.productDetail.OptionsVariantIds
    let index = ids.indexOf(id)
    if (id < 0) {
      if (index < 0) {
        ids.push(id)
        const theID = 0 - id
        const noneRow = state.productDetail.ProductsOptions.filter(a => a.ProductsOptionId === theID)
        if (noneRow.length > 0) {
          const noneVariants = noneRow[0].Variants.filter(a => a.OptionsVariantId !== id)
          for (var j = 0; j < noneVariants.length; j++) {
            const tmpIndex = ids.indexOf(noneVariants[j].OptionsVariantId)
            if (tmpIndex >= 0) {
              ids.splice(tmpIndex, 1)
            }
          }
        }
      } else {
        ids.splice(index, 1)
      }
    } else {
      if (index < 0) {
        for (var i = 0; i < state.productDetail.ProductsOptions.length; i++) {
          const existRow = state.productDetail.ProductsOptions[i].Variants.filter(a => a.OptionsVariantId === id)
          if (existRow.length <= 0) {
            continue
          }
          var exist = 0
          var firstExistId = 0
          for (var k = 0; k < state.productDetail.ProductsOptions[i].Variants.length; k++) {
            const tmpVarId = state.productDetail.ProductsOptions[i].Variants[k].OptionsVariantId
            if (ids.indexOf(tmpVarId) >= 0) {
              if (tmpVarId < 0) {
                ids.splice(ids.indexOf(tmpVarId), 1)
              } else {
                firstExistId = tmpVarId
                exist++
              }
            }
          }
          if (exist >= state.productDetail.ProductsOptions[i].UpTo && state.productDetail.ProductsOptions[i].UpTo > 0) {
            ids.splice(ids.indexOf(firstExistId), 1)
          }
        }
        ids.push(id)
      } else {
        ids.splice(index, 1)
      }
    }
    state.productDetail.OptionsVariantIds = ids
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/product/product.js